<template>
  <div class="meal-detail">
    <!-- 顶部轮播图组件 -->
    <div class="swipe-warp" v-if="drugsImage.length > 0">
      <swipe :autoplay="3000">
        <swipe-item v-for="(item, index) in drugsImage" :key="index">
          <img :src="item" class="slide-image" @click="preview(drugsImage, index)" />
        </swipe-item>
      </swipe>
    </div>

    <div class="meal-info">
      <drugTag :product="info" :size="20" />
      <h3 class="meal-name">
        <pointPrice :product="info" />
      </h3>
      <div class="product-info">
        <div class="product-item" v-for="(item, index) in info.goodsSettingVoList" :key="index">
          <div class="product-content">
            <van-image fit="cover" :src="item.goodsIcon" :alt="item.goodsName" class="product-image" />
            <span class="product-name">{{ item.goodsName }}</span>
          </div>
          <span class="product-num"><span class="num-tip">数量：</span>{{ item.mealNum }}</span>
        </div>
      </div>
    </div>

    <div class="info-list">
      <cell-group>
        <!-- <cell title="分类" :value="packageTypeAll.getValueByKey(info.goodsType)" /> -->
        <cell title="库存" :value="info.stock" />
        <cell title="厂家" :value="info.manufacturer" />
        <cell title="产地" :value="info.origin" />
        <cell title="服用频率" :value="info.dosageFrequency" />
        <cell title="服用方法" :value="info.usageMethod" />
        <cell title="剂量" :value="info.dosageAmount" />
        <cell title="禁忌" :value="info.prohibitedGroups" />
      </cell-group>
    </div>

    <div class="img-list-box">
      <img
        class="img-item"
        v-for="(item, index) in detailImage"
        :key="index"
        :src="item"
        mode="widthFix"
        style="width: 100%"
        @click="preview(detailImage, index)"
      />
      <div style="height: 100px;"></div>
    </div>

    <goods-action>
      <goods-action-icon icon="revoke" text="返回" @click="goBack" />
      <!-- <goods-action-icon icon="chat-o" text="客服" @click="goTel" /> -->
      <goods-action-icon icon="cart" text="购物车" @click="toCart" />
      <goods-action-button type="warning" text="加入购物车" @click="addToCart" />
      <!-- <goods-action-button type="danger" v-if="info.medicineType === 'RX'" text="开方买药" @click="goPrescribe" /> -->
      <goods-action-button type="danger" text="立即购买" @click="goBuy" />
    </goods-action>
  </div>
</template>

<script>
import pointPrice from '@/components/pointPrice';
import drugTag from '@/components/drugTag';
import { checkStock } from '@/lib/utils';

import {
  Swipe,
  SwipeItem,
  Cell,
  CellGroup,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Image as VanImage,
  ImagePreview
} from 'vant';

import services from '@/service';

import { packageTypeAll } from '@/enum/index';
import { wxAuthTo } from '@/lib/utils';
import wechat from '@/wechat';

export default {
  name: 'mallProductDetail',
  components: {
    pointPrice,
    drugTag,
    Swipe,
    SwipeItem,
    Cell,
    CellGroup,
    GoodsAction,
    GoodsActionIcon,
    GoodsActionButton,
    VanImage
  },
  data() {
    return {
      info: {
        drugsImage: '',
        detailImage: ''
      },
      packageTypeAll
    };
  },
  computed: {
    images() {
      const arr = [];
      if (!this.info.goodsMealId) return arr;
      this.info.goodsIcon && arr.push(this.info.goodsIcon);
      this.info.goodsImgs && arr.push(...this.info.goodsImgs.split(','));
      return arr;
    },
    drugsImage() {
      return this.info.drugsImage ? this.info.drugsImage.split(',') : [];
    },
    detailImage() {
      return this.info.detailImage ? this.info.detailImage.split(',') : [];
    },
    curId() {
      return this.$route.query.id;
    }
  },
  methods: {
    preview(images, startPosition) {
      ImagePreview({
        images,
        startPosition
      });
    },
    async getDetail() {
      if (!this.curId) return;
      const res = await services.mall.mealDetail(this.curId);
      this.info = res.data;
    },
    goBack() {
      this.$router.go(-1);
    },
    goTel() {
      // 跳转到客服电话的逻辑
    },
    // 加入购物车
    async addToCart() {
      await checkStock(this.info);
      const product = { ...this.info };

      const params = {
        goodsId: product.drugsId,
        number: 1,
        goodsName: product.name,
        salePrice: product.price,
        goodsIcon: product.drugsImage,
        addOrDeduct: 1
      };
      await services.mall.addMallCart(params);
      this.$toast('加入购物车成功');
    },
    toCart() {
      this.$router.replace({
        name: 'mallCart'
      });
    },
    async goBuy() {
      await checkStock(this.info);
      const arr = [
        {
          goodsId: this.info.drugsId,
          number: 1
        }
      ];

      wxAuthTo({
        routerName: 'mallOrderConfirm',
        query: {
          products: arr
        }
      });
    },
    goPrescribe() {
      const arr = [
        {
          goodsId: this.info.drugsId,
          number: 1
        }
      ];

      wxAuthTo({
        routerName: 'mallPrescription',
        query: {
          products: arr
        }
      });
    },
    handleMenuClick() {
      console.log('点击了分享');
      wechat.$wx.miniProgram.postMessage({
        data: {
          type: 'updateShare',
          shareData: {
            title: '好物分享',
            path: '/pages/h5Url/index?url=' + encodeURIComponent('mall-product-detail?id=' + this.curId)
          }
        }
      });
    }
  },
  mounted() {
    this.getDetail();
    // 监听菜单事件（真机有效）
    console.log('postMessage');
    this.handleMenuClick();
  }
};
</script>

<style lang="scss" scoped>
.van-cell__value {
  text-align: left;
}
.van-cell__title {
  width: 100px;
  flex: none;
}
.meal-detail {
  .swipe-warp {
    margin-bottom: $tb;
    .slide-image {
      width: 100%;
    }
  }

  .meal-info {
    background: #fff;
    margin-bottom: $tb;
    padding: 12px $lr;

    .meal-name {
      font-size: $size1;
      font-weight: 600;
      color: $black1;
    }

    .product-info {
      padding: 0 $lr;

      .product-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: $tb 0;
        border-bottom: 1px solid $bordercolor;
        font-size: $size2;

        .product-content {
          display: flex;
          align-items: center;

          &:last-child {
            border-bottom: none;
          }
          .product-image {
            width: 60px;
            height: 40px;
            margin-right: $lr;
            border-radius: 4px;
            overflow: hidden;
          }
          .product-name {
            font-weight: 500;
            color: $black1;
          }
        }
        .product-num {
          font-weight: 500;

          .num-tip {
            color: $gray2;
            font-size: $size6;
          }
        }
      }
    }

    .info-list {
      margin: $tb 0;

      .cell__value {
        color: $gray2;
      }
    }
  }

  .img-list-box {
    font-size: 0;
    margin-top: $edge2;
  }
}
</style>
